// Pagination.js
import React from "react";

const Pagination = ({ pageNo, totalPage, setPageNo }) => {
    const getPagesToShow = () => {
        const pages = [];
        const start = Math.max(2, pageNo - 2);
        const end = Math.min(totalPage - 1, pageNo + 2);

        pages.push(1);
        if (start > 2) pages.push("...");
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        if (end < totalPage - 1) pages.push("...");
        if (totalPage > 1) pages.push(totalPage);
        return pages;
    };

    return (
        <div className="row mt-3">
            <div className="col-sm-12 col-md-5">
                <div className="dataTables_info" role="status" aria-live="polite">
                    Showing page {pageNo} of {totalPage}
                </div>
            </div>
            <div className="col-sm-12 col-md-7" style={{ justifyContent: "right", display: "flex" }}>
                <div className="dataTables_paginate paging_simple_numbers">
                    <ul className="pagination">
                        <li className={`paginate_button page-item ${pageNo === 1 ? "disabled" : ""}`}>
                            <a href="#" className="page-link" onClick={(e) => {
                                e.preventDefault();
                                setPageNo(Math.max(pageNo - 1, 1));
                            }}>
                                Previous
                            </a>
                        </li>

                        {getPagesToShow().map((page, idx) => (
                            <li key={idx}
                                className={`paginate_button page-item ${pageNo === page ? "active" : ""} ${page === "..." ? "disabled" : ""}`}>
                                <a href="#" className="page-link" onClick={(e) => {
                                    e.preventDefault();
                                    if (page !== "...") setPageNo(page);
                                }}>
                                    {page}
                                </a>
                            </li>
                        ))}

                        <li className={`paginate_button page-item next ${pageNo >= totalPage ? "disabled" : ""}`}>
                            <a href="#" className="page-link" onClick={(e) => {
                                e.preventDefault();
                                setPageNo(Math.min(pageNo + 1, totalPage));
                            }}>
                                Next
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Pagination;
